//@ts-nocheck
import { capFirstLetter, chunkArray, shuffle } from "../../../utils/functions";
import getSubjectFromExpectation from "../utils/subject-determinant";
import { transformSplit } from "../utils/request-splitter";
import isEqual from "lodash.isequal";

export const transformInput = (inputArr: Array<any>) => {
  let result = {};
  let transformedInput = inputArr.map((child, index) => {
    let {
      classDetail: { class: studentClass, purpose, subjects },
    } = child;

    let newClassDetail = {
      class: studentClass.split(" ").join(""),
      purpose: purpose.split(" ").join("_"),
      subjects: subjects.map((subject) => subject.split(" ").join("_")),
    };

    return { ...child, classDetail: newClassDetail, id:index };
  });

  return { ...result, childDetails: transformedInput };
};

export const formatClass = (studentClass) => {
  return studentClass === "Preschool"
    ? studentClass
    : studentClass.slice(0, studentClass.length - 1) +
        " " +
        studentClass.slice(-1);
};

export const formatValue = (string) => {
  return string.replace(/_/g, " ");
};

export const transformOutput = (data) => {
  let transformedOutput = data.childDetails.map((child) => {
    let {
      classDetail: { class: studentClass, purpose, subjects },
    } = child;

    let newClassDetail = {
      class: formatClass(studentClass),
      purpose: formatValue(purpose),
      subjects: subjects.map((subject) => formatValue(subject)),
    };

    return {
      ...child,
      classDetail: newClassDetail,
      displayName: child.name || child.firstName,
    };
  });
  return transformedOutput;
};

function getClassCategory(studentClass?: string) {
  if (studentClass === "Preschool") {
    return "Nursery";
  }
  return (studentClass || "").split(" ")[0];
}

function orderClassCategories(studentClasses: string[]) {
  let nurseryClasses = studentClasses.filter((item) => item === "Nursery");
  let primaryClasses = studentClasses.filter((item) => item === "Primary");
  let jssClasses = studentClasses.filter((item) => item === "JSS");
  let sssClasses = studentClasses.filter((item) => item === "SSS");

  return [...nurseryClasses, ...primaryClasses, ...jssClasses, ...sssClasses];
}

function capitalizeLessonDays(newSchedule, daysSelected) {
  let lessonDays = newSchedule.lessonDays.map((day) => capFirstLetter(day));
  let schedule = { ...newSchedule, lessonDays };

  let selectedDays = daysSelected.map((day) => capFirstLetter(day));
  return { schedule, selectedDays };
}

function getSubjectsAndClass(
  splitRequests: Array<{
    class: string[];
    [key: string]: any;
  }>
) {
  let totalSubjects: string[] = [];
  splitRequests.forEach(({ subjectGroup }) =>
    totalSubjects.push(...subjectGroup)
  );

  let studentClasses: string[] = [];
  splitRequests.forEach((split) =>
    split.class.forEach((item) => {
      if (item) {
        studentClasses.push(item);
      }
    })
  );

  let classCategories = studentClasses.map((studentClass) =>
    getClassCategory(studentClass)
  );
  classCategories = orderClassCategories([...new Set(classCategories)]);

  return { totalSubjects, studentClasses, classCategories };
}

function splitClasses(classes) {
  let secondaryClasses = classes.filter((item) => {
    return item.search("JSS") > -1 || item.search("SSS") > -1;
  });
  let remainingClasses = classes.filter(
    (item) => !secondaryClasses.includes(item)
  );
  return { secondaryClasses, remainingClasses };
}

function getDaysPerTeacher(split, subjects, selectedDays) {
  let numberOfDays =
    (split.subjectGroup.length / subjects.length) * selectedDays.length;

  numberOfDays = Math.round(numberOfDays) > 0 ? Math.round(numberOfDays) : 1;

  return numberOfDays;
}

export const generateSearchSubject = (childDetails, splitArray) => {
  let splitWithSeachSubject = splitArray.map((split) => {
    let expectations = childDetails
      .filter(({ firstName }) => split.names.includes(firstName))
      .map((split) => split.expectation);

    let searchSubject = getSubjectFromExpectation(
      expectations.toString(),
      split.subjectGroup
    );

    return { ...split, searchSubject };
  });

  return splitWithSeachSubject;
};

/**
 * Generates a new 'splitRequest' that uses the number of subjects each teacher
 * is assigned to determine the proportion of the the total days selected will be
 * assigned to each teacher.
 * @param {Array[Object]} requestSplit Array of each request split
 * @param {Array[String]} subjects All subjects requested for the whole request
 * @returns {Array[Object]}
 */
function splitDaysBySubjects(requestSplit, subjects, copy) {
  let newRequestSplit = [];
  let numberOfTeachers = requestSplit.length;

  let selectedDays = [...copy];
  shuffle(selectedDays);

  let daysIsMultipleOfTeachers = selectedDays.length % numberOfTeachers === 0;
  let averageDaysPerTeacher = selectedDays.length / numberOfTeachers;
  let maximumDays = Math.round(averageDaysPerTeacher);
  let subjectsPerGroup = requestSplit.map(
    ({ subjectGroup }) => subjectGroup.length
  );

  const hasEqualNumberOfSubjects = [...new Set(subjectsPerGroup)].length === 1;

  if (daysIsMultipleOfTeachers || hasEqualNumberOfSubjects) {
    let lessonDaysPerTeacher = chunkArray(selectedDays, maximumDays);

    newRequestSplit = requestSplit.map((split, index) => ({
      ...split,
      lessonDays: lessonDaysPerTeacher[index],
    }));
  } else {
    let daysPerTeacher = requestSplit.map((split) =>
      getDaysPerTeacher(split, subjects, selectedDays)
    );

    newRequestSplit = requestSplit.map((split, index) => ({
      ...split,
      lessonDays: selectedDays.splice(0, daysPerTeacher[index]),
    }));
  }
  return newRequestSplit;
}

export function rawGenerateLessonsForSplit(
  splitRequests,
  newSchedule,
  daysSelected
) {
  if (splitRequests.length > 0) {
  }
  let { schedule, selectedDays } = capitalizeLessonDays(
    newSchedule,
    daysSelected
  );
  let { totalSubjects, studentClasses, classCategories } =
    getSubjectsAndClass(splitRequests);

  let newRequestSplit = [];

  let isPrimaryAndJSSOnly = isEqual(classCategories, ["Primary", "JSS"]);
  let { secondaryClasses, remainingClasses } = splitClasses(studentClasses);

  let teacherOption =
    splitRequests.length > 0 && splitRequests[0].teacherOption;
  let isSeparateOrOneTeacher =
    teacherOption === "One teacher" || teacherOption === "Separate teachers";

  // if (isSeparateOrOneTeacher || secondaryClasses.length === 0) {
  if (isSeparateOrOneTeacher && secondaryClasses.length === 0) {
    newRequestSplit = splitRequests.map((split) => ({
      ...split,
      lessonDays: selectedDays,
    }));
  } else if (isPrimaryAndJSSOnly) {
    newRequestSplit = splitDaysBySubjects(
      splitRequests,
      totalSubjects,
      daysSelected
    );
  } else if (secondaryClasses.length > 0 && remainingClasses.length > 0) {
    let secondarySplit = splitRequests.filter((split) =>
      split.class.every((studentClass) =>
        secondaryClasses.includes(studentClass)
      )
    );
    let secondarySubjects = [];
    secondarySplit.forEach(({ subjectGroup }) =>
      secondarySubjects.push(...subjectGroup)
    );

    let remainingSplit = splitRequests.filter((split) =>
      split.class.every((studentClass) =>
        remainingClasses.includes(studentClass)
      )
    );

    let _remainingSplit = remainingSplit.map((split) => ({
      ...split,
      lessonDays: schedule.lessonDays,
    }));
    let _secondarySplit = splitDaysBySubjects(
      secondarySplit,
      secondarySubjects,
      selectedDays
    );
    newRequestSplit = [..._remainingSplit, ..._secondarySplit];
  } else {
    newRequestSplit = splitDaysBySubjects(
      splitRequests,
      totalSubjects,
      selectedDays
    );
  }
  if (newRequestSplit.length == 0 && splitRequests.length > 0) {
    newRequestSplit = splitRequests;
  }

  return newRequestSplit;
}

export const splitSchedule = (newSchedule, daysSelected, splitRequests) => {
  /**
   * Capitalizes the first letter of each weekday in the lesson schedule
   */
  function capitalizeLessonDays() {
    let lessonDays = newSchedule.lessonDays.map((day) => capFirstLetter(day));
    let schedule = { ...newSchedule, lessonDays };

    let selectedDays = daysSelected.map((day) => capFirstLetter(day));
    return { schedule, selectedDays };
  }

  function getSubjectsAndClass() {
    let totalSubjects = [];
    splitRequests.forEach(({ subjectGroup }) =>
      totalSubjects.push(...subjectGroup)
    );

    let studentClasses = [];
    splitRequests.forEach((split) =>
      split.class.forEach((item) => studentClasses.push(item))
    );

    let classCategories = studentClasses.map((studentClass) =>
      getClassCategory(studentClass)
    );
    classCategories = orderClassCategories([...new Set(classCategories)]);

    return { totalSubjects, studentClasses, classCategories };
  }

  let { schedule, selectedDays } = capitalizeLessonDays();

  let { totalSubjects, studentClasses, classCategories } =
    getSubjectsAndClass();

  /**
   * Generates a new "splitRequest" array that includes the number of days of lessons
   * each split or teacher is assigned per week based on if the user selected to have
   * One Teacher, Separate Teachers or Specialized Teachers.
   *
   */
  function generateLessonsForSplit() {
    return rawGenerateLessonsForSplit(splitRequests, newSchedule, daysSelected);
  }

  /**
   * Generates a new 'splitRequest' that uses the number of subjects each teacher
   * is assigned to determine the proportion of the the total days selected will be
   * assigned to each teacher.
   * @param {Array[Object]} requestSplit Array of each request split
   * @param {Array[String]} subjects All subjects requested for the whole request
   * @returns {Array[Object]}
   */
  function splitDaysBySubjects(requestSplit, subjects) {
    let newRequestSplit = [];
    let numberOfTeachers = requestSplit.length;

    shuffle(selectedDays);

    let daysIsMultipleOfTeachers = selectedDays.length % numberOfTeachers === 0;
    let averageDaysPerTeacher = selectedDays.length / numberOfTeachers;
    let maximumDays = Math.round(averageDaysPerTeacher);
    let subjectsPerGroup = requestSplit.map(
      ({ subjectGroup }) => subjectGroup.length
    );

    const hasEqualNumberOfSubjects =
      [...new Set(subjectsPerGroup)].length === 1;

    if (daysIsMultipleOfTeachers || hasEqualNumberOfSubjects) {
      let lessonDaysPerTeacher = chunkArray(selectedDays, maximumDays);

      newRequestSplit = requestSplit.map((split, index) => ({
        ...split,
        lessonDays: lessonDaysPerTeacher[index],
      }));
    } else {
      let daysPerTeacher = requestSplit.map((split) =>
        getDaysPerTeacher(split, subjects)
      );

      newRequestSplit = requestSplit.map((split, index) => ({
        ...split,
        lessonDays: selectedDays.splice(0, daysPerTeacher[index]),
      }));
    }
    return newRequestSplit;
  }

  function getDaysPerTeacher(split, subjects) {
    let numberOfDays =
      (split.subjectGroup.length / subjects.length) * selectedDays.length;

    numberOfDays = Math.round(numberOfDays) > 0 ? Math.round(numberOfDays) : 1;

    return numberOfDays;
  }

  let newRequestSplit = generateLessonsForSplit();

  return newRequestSplit;
};

export function determineNoOfTeachers(childDetails, splitRequests = []) {
  let teacherSplitOptions = transformSplit(childDetails);
  let initialTeacherOption =
    splitRequests.length > 0 ? splitRequests[0].teacherOption : "";

  let teacherOptions = Object.keys(teacherSplitOptions);
  let initialInputValue = teacherOptions.includes(initialTeacherOption)
    ? initialTeacherOption
    : "";
  return { teacherSplitOptions, initialInputValue };
}
